import {
  CirclesThree,
  Fire,
  Hexagon as HexagonIcon,
  MapPin,
  MapTrifold
} from '@phosphor-icons/react'
import { useAggregateOptions } from '~map-preview/states/boundaries'
import { useCategoryOptions } from '~map-preview/states/map'
import {
  Marker,
  Category,
  Heatmap,
  Aggregate,
  Hexagon
} from '~map-settings/types/__generated/gql/graphql'
import { useNumericProperties } from '~map-preview/states/map'
import { useMapSettingsStore } from '~map-preview/states/mapSettings'

const visualizations = [
  {
    parent: 'point',
    id: 'marker',
    type: 'marker',
    label: 'Markers',
    Icon: MapPin
  } as Marker,
  {
    parent: 'point',
    id: 'category',
    type: 'category',
    label: 'Categories',
    property: '',
    Icon: CirclesThree
  } as Category,
  {
    parent: 'point',
    id: 'heatmap',
    type: 'heatmap',
    label: 'Heatmap',
    Icon: Fire
  } as Heatmap
]

export const useGetDefaultVisualizationOptions = () => {
  const { defaultVisualization } = useMapSettingsStore()
  const options = useAggregateOptions()
  const categoryOptions = useCategoryOptions()
  const numericProperties = useNumericProperties()

  const defaultProperty =
    numericProperties.length > 0 ? numericProperties[0]?.name : 'count'

  let visualizationOptions = visualizations
  if (options.length > 0) {
    visualizationOptions = visualizations.concat(
      options.map(
        (item) =>
          ({
            parent: 'aggregate',
            id: item.value,
            type: 'aggregate',
            property: item.value,
            aggregate: defaultProperty,
            display: '2D',
            label: item.label,
            Icon: MapTrifold
          } as Aggregate)
      )
    )
  }
  visualizationOptions.push({
    parent: 'aggregate',
    type: 'hexagon',
    property: '',
    id: 'hexagon',
    label: 'Hexagon',
    aggregate: defaultProperty,
    size: 'medium',
    display: '2D',
    Icon: HexagonIcon
  } as Hexagon)

  if (categoryOptions.length === 0) {
    const categoryOption = visualizationOptions.find(
      (item) => item.type === 'category'
    )
    if (categoryOption) categoryOption['visible'] = false
  }

  return {
    options: defaultVisualization ? visualizationOptions : visualizations,
    selected:
      (defaultVisualization && Object.values(defaultVisualization)[0]) ||
      visualizations[0]
  }
}
